<template>
	<div :class="{ 'col-span-2': variable.type === 'dropdown' }" v-if="variable">
		<BaseInput
			v-if="variable.type === 'text'"
			v-model="variable.value"
			:label="variable.label"
			@input="$emit('input')"
			:sublabel="variable.sublabel"
			ref="text"
			:required="required"
		/>
		<BaseInputNumber
			v-else-if="variable.type === 'number'"
			v-model="variable.value"
			:label="variable.label"
			@input="$emit('input')"
			:label-class="labelClass"
			:precision="2"
			:sublabel="variable.sublabel"
			ref="number"
			:required="required"
		/>
		<BaseInputNumber
			v-else-if="variable.type === 'percent'"
			v-model="variable.value"
			:currency="{ prefix: '', suffix: ' %' }"
			:label="variable.label"
			@input="$emit('input')"
			:label-class="labelClass"
			:sublabel="variable.sublabel"
			:value-range="{ min: 0, max: 99 }"
			ref="percent"
			:required="required"
		/>
		<div v-else-if="variable.type === 'dropdown'" class="grid grid-cols-2 gap-4">
			<BaseSelect
				v-model="variable.value"
				:label="variable.label"
				:options="getOptions(variable.key)"
				@input="$emit('input')"
				:sublabel="variable.sublabel"
				:required="required"
				:ref="variable.id"
			/>
			<BaseInputNumber
				v-if="variable.value && variable.value.show_lack_hersteller_system"
				:label="$t('paintmaterial')"
				:precision="2"
				:value="getDropdownValueVariable.value"
				:value-range="{ min: 0, max: 999 }"
				:label-class="labelClass"
				sublabel="(EUR / ME)"
				@input="updateDropdownValue"
				:required="required"
				ref="number_lackmaterial"
			/>
			<BaseInputNumber
				v-if="variable.value && variable.value.show_eurolack"
				:label="$t('material_costs_per_point')"
				:precision="2"
				:value="getDropdownValueVariable.value"
				:value-range="{ min: 0, max: 999 }"
				:sublabel="$t('euro_brackets')"
				:label-class="labelClass"
				@input="updateDropdownValue"
				ref="dropdown"
				:required="required"
			/>
			<BaseInputNumber
				v-if="variable.value && variable.value.show_currency"
				:label="variable.label"
				:precision="2"
				:value="getDropdownValueVariable.value"
				:value-range="{ min: 0, max: 999 }"
				:sublabel="$t('euro_brackets')"
				:label-class="labelClass"
				@input="updateDropdownValue"
				ref="dropdown_currency"
				:required="required"
			/>
			<BaseInputNumber
				v-else-if="variable.value && variable.value.show_number"
				:currency="null"
				:label="variable.label"
				:precision="1"
				:value="getDropdownValueVariable.value"
				:value-range="{ min: 0, max: 99 }"
				:sublabel="$t('hour_brackets')"
				:label-class="labelClass"
				@input="updateDropdownValue"
				ref="dropdown_hour"
				:required="required"
			/>
			<BaseInputNumber
				v-else-if="variable.value && variable.value.show_percent"
				:currency="{ prefix: '', suffix: ' %' }"
				:label="variable.label"
				:value="getDropdownValueVariable.value"
				:value-range="{ min: 0, max: 99 }"
				:sublabel="$t('percent_brackets')"
				:label-class="labelClass"
				@input="updateDropdownValue"
				ref="dropdown_percent"
				:required="required"
			/>
			<BaseInput
				v-else-if="variable.value && variable.value.show_text"
				:label="variable.label"
				:value="getDropdownValueVariable.value"
				:sublabel="$t('free_brackets')"
				@input="updateDropdownValue"
				ref="dropdown_custom"
				:required="required"
			/>
		</div>
	</div>
</template>
<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import Validate from '@/mixins/Validate';

export default {
	name: 'CompanyVariable',
	components: { BaseInput, BaseInputNumber, BaseSelect },
	mixins: [Validate],
	props: {
		variable: {},
		variables: {},
		required: { default: false },
		labelClass: { default: '' },
	},
	watch: {
		variable: {
			immediate: true,
			handler() {
				if (this.variable?.type === 'number' && isNaN(this.variable.value)) {
					this.variable.value = null;
				} else if (this.variable?.key === 'verbringungskosten_wert' && isNaN(this.variable.value)) {
					this.variable.value = null;
				}

				if (this.variable?.type === 'dropdown' && this.variable.value) {
					this.variable.value = this.getOptions(this.variable.key).find(option => {
						const value = this.variable.value.value || this.variable.value;
						return option.value === value;
					});
				}
			},
		},
	},
	computed: {
		getDropdownValueVariable() {
			const key = `${this.variable.key}_wert`;
			return this.variables[key];
		},
	},
	methods: {
		getOptions(key) {
			if (key === 'lackmaterial') {
				return [
					{
						display: this.$t('paint_salary_includes_material'),
						value: 'includes',
						subValue: null,
					},
					{
						display: this.$t('paint_material_percent_salary_based'),
						value: 'percent',
						show_percent: true,
						subValue: null,
					},
					{
						display: this.$t('paint_manufacturer_system'),
						value: 'lack_hersteller_system',
						show_lack_hersteller_system: true,
						subValue: null,
					},
					{
						display: this.$t('eur_paint_points'),
						value: 'eurolack',
						show_eurolack: true,
						subValue: null,
					},
				];
			} else if (key === 'verbringungskosten') {
				return [
					{
						display: this.$t('does_not_apply'),
						value: 'includes',
						subValue: null,
					},
					{
						display: this.$t('display_in_hours'),
						value: 'hours',
						show_number: true,
						subValue: null,
					},
					{
						display: this.$t('display_in_eur'),
						value: 'currency',
						show_currency: true,
						subValue: null,
					},
				];
			}
			return [];
		},
		updateDropdownValue(value) {
			const variable = this.getDropdownValueVariable;
			variable.value = value;
			this.$emit('input');
			return variable;
		},
	},
};
</script>
